import * as React from 'react';
import { statusUnavailable } from '@grandvisionhq/state';

const ValidatingForm = ({ addressBook , billingAddressForm  })=>{
    if (!addressBook || statusUnavailable(addressBook)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": "addresses-section-container-validating-form",
        style: {
            display: 'none'
        }
    }, billingAddressForm);
};

export { ValidatingForm };
//# sourceMappingURL=ValidatingForm.js.map
